"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var loadMoreButton_1 = __importDefault(require("@l2p/ui-components/src/LoadMoreButton/loadMoreButton"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var MobileRow_1 = __importDefault(require("./MobileRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useTableData_1 = require("./useTableData");
var LIMIT = 10;
var BetsList = function () {
    var _a, _b, _c, _d, _e, _f;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _g = (0, react_1.useState)(false), mounted = _g[0], setMounted = _g[1];
    var _h = (0, react_1.useState)(LIMIT), limit = _h[0], setLimit = _h[1];
    var _j = (0, react_1.useState)({ from: undefined, to: undefined }), dates = _j[0], setDates = _j[1];
    var _k = (0, react_1.useState)(undefined), roundsData = _k[0], setRoudnsData = _k[1];
    var onDateFilterChange = (0, react_1.useCallback)(function (dates) { return setDates(dates); }, []);
    var _l = (0, swr_hooks_1.useGetGamesRounds)({
        page: 1,
        limit: limit,
        filter: {
            startTime: dates.from ? new Date(dates.from).getTime() : undefined,
            endTime: dates.to ? new Date(dates.to).getTime() : undefined,
        },
    }), data = _l.data, isLoading = _l.isLoading, isValidating = _l.isValidating, getGamesRounds = _l.getGamesRounds;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var tableData = (0, useTableData_1.useTableData)((roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) || []);
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    (0, react_1.useEffect)(function () {
        getGamesRounds({ page: 1, limit: limit });
    }, [getGamesRounds, dates.from, dates.to, limit]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (((_a = data === null || data === void 0 ? void 0 : data.edges) === null || _a === void 0 ? void 0 : _a.length) || ((_b = data === null || data === void 0 ? void 0 : data.edges) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            setRoudnsData(data);
        }
    }, [(_a = data === null || data === void 0 ? void 0 : data.edges) === null || _a === void 0 ? void 0 : _a.length]);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (isLoading && !((_b = roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) === null || _b === void 0 ? void 0 : _b.length))
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    var shouldViewPaginate = (data === null || data === void 0 ? void 0 : data.totalCount) > limit;
    var maxPage = Math.ceil((data === null || data === void 0 ? void 0 : data.totalCount) / limit);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
                react_1.default.createElement("div", null),
                react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates })),
            Object.keys(breakpoints).length > 0 &&
                !breakpoints.mobile &&
                !breakpoints.tablet && (react_1.default.createElement(ui_components_1.DataTable, { loading: isLoading && !((_c = roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) === null || _c === void 0 ? void 0 : _c.length), data: tableData, lazy: false, itemsPerPage: 10 })),
            Object.keys(breakpoints).length > 0 &&
                (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                react_1.default.createElement(ui_components_1.MobileDataTable, { lazy: false, loading: isLoading && !((_d = roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) === null || _d === void 0 ? void 0 : _d.length), data: tableData.rows, rowComponent: MobileRow_1.default }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreWrap }, Boolean((_e = roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) === null || _e === void 0 ? void 0 : _e.length) &&
                ((_f = roundsData === null || roundsData === void 0 ? void 0 : roundsData.edges) === null || _f === void 0 ? void 0 : _f.length) < (roundsData === null || roundsData === void 0 ? void 0 : roundsData.totalCount) && (react_1.default.createElement(loadMoreButton_1.default, { onClick: function () { return setLimit(limit + LIMIT); }, loading: isLoading || isValidating }, t('loadMore')))))));
};
exports.default = BetsList;
